var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.multiple ? 'multiple-selector' : 'single-selector',_vm._g(_vm._b({ref:"selector",tag:"component"},'component',_vm.selectorProps,false),_vm.$listeners),[_c('template',{slot:"suffix-icon"},[_vm._t("suffix-icon")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }